<template>
  <v-row>  
    <v-dialog v-model="showDialog" max-width="577px" max-height="581px" style="z-index: 1019;">
      <v-card class="pa-0">
        <v-card-text class="ma-0 pa-2 d-flex justify-center align-center">
          <div style="width: 100%; height: 100%; display: flex; flex-wrap: wrap;">
            <div v-for="(c, index) in colors" :key="index" @click.stop="color = colors[index]" class="d-flex justify-center align-center" :style="`padding: 9px; width: 35px; height: 32px; cursor: pointer; background-color: ${colors[index]};`">
              <v-icon v-if="colors[index] === color" small :color="invertColor(colors[index])">check_circle</v-icon>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#185EA9" text @click="ok()" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.ok").toUpperCase() }}
          </v-btn>
          <v-btn text @click="close()" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.cancel").toUpperCase()}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseModule from "./BaseModule.js";

export default {
  name: "ColorDialog",
  mixins: [BaseModule],
  data() {
    return {
      showDialog: false,
      colors: [],
      color: '#F44336',
      msgCb: null
    };
  },
  mounted() {
		this.colors = this.constants.COLORS.map(x => x.hex);
  },
  methods: {
    open(color, msgCb) {
      if (color) {
        this.color = this.convertColorToHex(color);
      }
      this.msgCb = msgCb;      
      this.showDialog = true;
    },
    ok() {
      this.showDialog = false;
      if (this.msgCb) {
        this.msgCb(this.constants.COLORS.find(x => x.hex === this.color).name);
      }
    },
    close() {
      this.showDialog = false;
    },
    invertColor(hex) {
      if (hex.indexOf('#') === 0) {
          hex = hex.slice(1);
      }
    
      // convert 3-digit hex to 6-digits.
      if (hex.length === 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      
      // invert color components
      let r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
          g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
          b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
      
      // pad each with zeros and return
      return `#${this.padZero(r)}${this.padZero(g)}${this.padZero(b)}`;
    },
    padZero(str, len) {
      len = len || 2;
      var zeros = new Array(len).join('0');
      return (zeros + str).slice(-len);
    }
  },
};
</script>
